import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, userDetails } from '../services/AppInsightsService';
import { PrivateRoute } from './PrivateRoute';
import { Callback } from '../components/Auth/Callback';
import HomePageComponent from '../components/HomePage/HomePage';

function Routes() {
  return (
    <AppInsightsContext.Provider value={{ reactPlugin, userDetails }}>
      <Router>
        <Suspense fallback={<div>Loading...</div>}>
          <PrivateRoute exact path="/" component={HomePageComponent} />
          <Switch>
            <PrivateRoute
              exact
              path="/ticket/details/:ticketNumber"
              component={HomePageComponent}
            />

            <PrivateRoute
              exact
              path="/ticket/creation"
              component={HomePageComponent}
            />
            <PrivateRoute
              exact
              path="/action/list"
              component={HomePageComponent}
            />
            <PrivateRoute
              exact
              path="/action/creation"
              component={HomePageComponent}
            />
            <PrivateRoute
              exact
              path="/ticket/edit/:ticketNumber"
              component={HomePageComponent}
            />

            <PrivateRoute
              exact
              path="/wagon/search"
              component={HomePageComponent}
            />

            <PrivateRoute
              exact
              path="/wagon/details/:wagonNumber"
              component={HomePageComponent}
            />
            <PrivateRoute
              exact
              path="/invoices/add"
              component={HomePageComponent}
            />
            <PrivateRoute
              exact
              path="/invoices/research"
              component={HomePageComponent}
            />
            <PrivateRoute
              exact
              path="/analytics/wagon-availability"
              component={HomePageComponent}
            />
            <PrivateRoute
              exact
              path="/analytics/wagon-simulation"
              component={HomePageComponent}
            />
            <PrivateRoute
              exact
              path="/analytics/maintenance-status"
              component={HomePageComponent}
            />
            <PrivateRoute
              exact
              path="/analytics/workshop-time"
              component={HomePageComponent}
            />
            <PrivateRoute
              exact
              path="/analytics/total-cost"
              component={HomePageComponent}
            />
            <PrivateRoute
              exact
              path="/analytics/monitoring"
              component={HomePageComponent}
            />
            <PrivateRoute
              exact
              path="/parameters/revision"
              component={HomePageComponent}
            />
            <PrivateRoute
              exact
              path="/revisionplan/plannedprediction"
              component={HomePageComponent}
            />
            <PrivateRoute
              exact
              path="/revisionplan/revisionPlanUpload"
              component={HomePageComponent}
            />
            <PrivateRoute
              exact
              path="/parameters/parameterAr"
              component={HomePageComponent}
            />
            <PrivateRoute
              exact
              path="/parameters/businessNeed"
              component={HomePageComponent}
            />
            <PrivateRoute
              exact
              path="/parameters/durationParameter"
              component={HomePageComponent}
            />
            <PrivateRoute
              exact
              path="/parameters/parametersScraping"
              component={HomePageComponent}
            />
            <PrivateRoute
              exact
              path="/parameters/gcuDamageCode"
              component={HomePageComponent}
            />
            <PrivateRoute
              exact
              path="/parameters/contactsEmail"
              component={HomePageComponent}
            />
            <PrivateRoute
              exact
              path="/parameters/actualWorkshops"
              component={HomePageComponent}
            />
            <Route exact path="/callback" component={Callback} />
          </Switch>
        </Suspense>
      </Router>
    </AppInsightsContext.Provider>
  );
}

export default Routes;
